import React, { useEffect, useState } from 'react';

const PluginLoader = ({ src }: { src: string }) => {
  const [PluginComponent, setPluginComponent] =
    useState<React.ComponentType | null>(null);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;

    script.onload = () => {
      const loadedComponent = (window as any).PluginComponent;
      console.log('Loaded component:', loadedComponent);

      if (typeof loadedComponent === 'function') {
        setPluginComponent(() => loadedComponent);
      } else {
        console.error(
          'PluginComponent is not a valid React component:',
          loadedComponent
        );
      }
    };

    script.onerror = () => {
      console.error('Failed to load plugin script:', src);
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
      setPluginComponent(null);
    };
  }, [src]);

  if (!PluginComponent) {
    return <div>Loading plugin...</div>;
  }

  try {
    return <PluginComponent />;
  } catch (error) {
    console.error('Error rendering plugin:', error);
    return <div>Error loading plugin</div>;
  }
};

export default PluginLoader;
